var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82AFFF"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 155.51,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 21.28
  }), /*#__PURE__*/React.createElement("rect", {
    y: 335.21,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 21.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M121.184,127.898c-27.584,0-49.942-22.306-49.942-49.791c0-27.586,22.358-49.991,49.942-49.991   c0.105,0,0.211,0.001,0.315,0.002c1.623,0.022,2.193-2.136,0.762-2.903c-8.494-4.552-18.188-7.129-28.494-7.056   c-33.005,0.236-59.814,27.586-59.465,60.59c0.346,32.665,27.05,59.105,59.895,59.105c10.165,0,19.722-2.571,28.109-7.061   c1.427-0.764,0.85-2.923-0.768-2.898C121.421,127.897,121.303,127.898,121.184,127.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M160.292,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C161.806,113.263,160.581,113.263,160.292,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M199.225,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C200.739,113.263,199.514,113.263,199.225,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M278.225,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C279.739,113.263,278.514,113.263,278.225,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M316.972,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C318.486,113.263,317.261,113.263,316.972,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M199.225,67.77l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C200.739,66.904,199.514,66.904,199.225,67.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M238.972,67.77l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C240.486,66.904,239.261,66.904,238.972,67.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M278.225,67.77l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C279.739,66.904,278.514,66.904,278.225,67.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M316.972,67.77l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C318.486,66.904,317.261,66.904,316.972,67.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M238.972,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C240.486,113.263,239.261,113.263,238.972,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M238.972,21.411l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C240.486,20.546,239.261,20.546,238.972,21.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M278.225,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C279.739,113.263,278.514,113.263,278.225,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M316.972,114.129l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C318.486,113.263,317.261,113.263,316.972,114.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M278.225,21.411l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C279.739,20.546,278.514,20.546,278.225,21.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M316.972,21.411l-2.231,6.688l-7.05,0.055c-0.913,0.007-1.291,1.172-0.557,1.714l5.672,4.188   l-2.127,6.722c-0.275,0.87,0.716,1.59,1.458,1.059l5.736-4.1l5.736,4.1c0.743,0.531,1.733-0.189,1.458-1.059l-2.127-6.722   l5.672-4.188c0.734-0.542,0.356-1.707-0.557-1.714l-7.05-0.055l-2.231-6.688C318.486,20.546,317.261,20.546,316.972,21.411z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/UZ.96d4a169f7ca80819efc32bd370f2e73.svg";
export { ForwardRef as ReactComponent };